import { WIDGET_PREVIEW_SIZE } from '../constants'

function parseElementStyle(props) {
  const { widget, zModifier, isRenderingInsideLayerTool, isRenderingInsideAceEditor } = props
  let widgetLayout = widget.layout || {}
  let widgetBaseStyle = widget.baseStyle ? JSON.parse(JSON.stringify(widget.baseStyle)) : {}
  let animationTypeMap = {}
  // In preparation for multiple animations, animation fill mode is converted to 'forwards' instead of 'both'.
  // This is because the 'both' fill mode does not work with multiple animations. This then requires us to set
  // the position of the actual widget to the starting point of the animation otherwise the widget will become visible
  // in the end position of the animation and not the starting position.
  if (widget.animations?.length && !isRenderingInsideAceEditor) {
    widget.animations.forEach(a => {
      if (
        (a.type !== 'transition' && animationTypeMap[a.type]) ||
        (a.type === 'transition' && animationTypeMap[a.targetStyle.name])
      ) {
        return
      }

      switch (true) {
        case a.type === 'move' || a.type === 'resize':
          animationTypeMap['move'] = true
          animationTypeMap['resize'] = true
          widgetLayout = {
            ...widgetLayout,
            x: a.animationStates[0].layout.x,
            y: a.animationStates[0].layout.y,
            width: a.animationStates[0].layout.width,
            height: a.animationStates[0].layout.height,
          }
          break
        case a.type === 'transition':
          animationTypeMap[a.targetStyle.name] = true
          widgetBaseStyle[a.targetStyle.name] = a.animationStates[0].transition.value
          break
        case a.type === 'rotation':
          animationTypeMap[a.type] = true
          widgetLayout = {
            ...widgetLayout,
            zRotation: a.animationStates[0].rotation.value,
          }
          widgetBaseStyle.horizontal = a.animationStates[0].horizontal.value
          widgetBaseStyle.vertical = a.animationStates[0].vertical.value
          break
      }
    })
  }

  // if inside ace editor, set to current base style, not starting point of animation
  if (isRenderingInsideAceEditor) {
    widgetBaseStyle = widget.baseStyle
  }
  const widgetOrientation = widget.value.config.orientation
  const scale =
    isRenderingInsideLayerTool && WIDGET_PREVIEW_SIZE / Math.max(widgetLayout.width, widgetLayout.height) < 1
      ? `scale(${WIDGET_PREVIEW_SIZE / Math.max(widgetLayout.width, widgetLayout.height)})`
      : ''

  const st = {
    position: 'absolute',
    overflow: 'hidden',
    // hide widget if visibility off and widget is inside template (does not hide widget from actual ad)
    // strict false check is necessary as isLayerVisible undefined should default to true (DO NOT CHANGE to falsy !widget.isLayerVisible check)
    // widget visibility by default should be true
    display:
      widget.isLayerVisible === false && isRenderingInsideAceEditor && !isRenderingInsideLayerTool ? 'none' : 'flex',
    'flex-direction': `${widgetOrientation === 'vertical' ? 'column' : 'row'}`,

    top: isRenderingInsideLayerTool ? '' : `${widgetLayout.y}px`,
    left: isRenderingInsideLayerTool ? '' : `${widgetLayout.x}px`,
    'z-index': widgetLayout.z + zModifier,

    background: widgetBaseStyle.background || 'transparent',
    // 0 values do not get rendered so we use percent for 0 values
    opacity: widgetBaseStyle.opacity === 0 ? '0%' : widgetBaseStyle.opacity || 1,

    cursor: 'pointer',

    'border-width': `${widgetBaseStyle['border-width'] || 0}px`,
    'border-radius': `${widgetBaseStyle['border-radius'] * 100 || 0}px`,
    'border-style': widgetBaseStyle['border-style'],
    'border-color': widgetBaseStyle['border-color'],

    transform: isRenderingInsideLayerTool
      ? `${scale}`
      : `rotate(${widgetLayout.zRotation || 0}deg) rotateY(${widgetBaseStyle.horizontal ||
          0}deg) rotateX(${widgetBaseStyle.vertical || 0}deg)`,
  }

  return st
}

function dotElementStyle(props, options) {
  const { isFirstDot, isLastDot, isPreviewDot } = options
  const { widget } = props
  const widgetDotStyle = widget.value.config || {}
  const widgetOrientation = widget.value.config.orientation || {}
  let borderStyle = ''
  if (isPreviewDot && !isFirstDot) {
    borderStyle = 'dotted 1px'
  } else if (widgetDotStyle.defaultDotBorderStyle != 'none' && widgetDotStyle.defaultDotBorderWidth) {
    borderStyle = `${widgetDotStyle.defaultDotBorderStyle} ${widgetDotStyle.defaultDotBorderWidth}px ${widgetDotStyle.defaultDotBorderColor}`
  }

  const dotSt = {
    height: `${widgetDotStyle.dotHeight}px`,
    width: `${widgetDotStyle.dotWidth}px`,
    'border-radius': '50%',
    'margin-right': widgetOrientation === 'horizontal' && !isLastDot ? `${widgetDotStyle.dotSpacing}px` : '0',
    'margin-bottom': widgetOrientation === 'vertical' && !isLastDot ? `${widgetDotStyle.dotSpacing}px` : '0',
    'background-color': isPreviewDot && !isFirstDot ? 'white' : widgetDotStyle.dotNotHoverColor,
    border: borderStyle,
    '-webkit-box-sizing': 'border-box',
    '-moz-box-sizing': 'border-box',
    'box-sizing': 'border-box',
  }
  return dotSt
}

function withDivContainer(sourceElement, $h) {
  //context was bound to this
  const props = this.props
  //account for any native events the template editor is trying to apply (ie mouseover, contextmenu)
  const nativeOn = (this.data && this.data.nativeOn) || {}

  // Generate hover event styling
  // Perry Todo - This whole hover-event-styling should be made into an Add-On that can be applied to any widget, see comment below
  const {
    dotHoverColor,
    dotAtColor,
    hoverBackground,
    dotHoverBorderStyle,
    dotHoverBorderColor,
    dotHoverBorderWidth,
    selectedDotBorderColor,
    selectedDotBorderWidth,
    selectedDotBorderStyle,
  } = props.widget.value.config
  const hoverBackgroundCss = hoverBackground ? `background:${hoverBackground} !important;` : ''
  const hoverBorderCss =
    dotHoverBorderStyle != 'none' && dotHoverBorderWidth
      ? `border:${dotHoverBorderStyle} ${dotHoverBorderWidth}px ${dotHoverBorderColor} !important;`
      : ''
  const dotHoverColorCss = dotHoverColor ? `background:${dotHoverColor} !important;` : ''
  const dotAtColorCss = dotAtColor ? `background:${dotAtColor} !important;` : ''
  const dotSelectedBorderStyle =
    selectedDotBorderStyle != 'none' && selectedDotBorderWidth
      ? `border:${selectedDotBorderStyle} ${selectedDotBorderWidth}px ${selectedDotBorderColor} !important;`
      : ''
  const hoverStyles = $h('style', {}, [
    `#${props.widgetId}:hover { ${hoverBackgroundCss} }
    #${props.widgetId} :hover { ${dotHoverColorCss} ${hoverBorderCss} }
    #${props.widgetId} .selectedDotNavButton { ${dotAtColorCss} pointer-events: none; ${dotSelectedBorderStyle}}`,
  ])

  return $h(
    'div',
    {
      on: {
        ...nativeOn,
      },
      style: parseElementStyle(props),
      /*
      At time of writing, AddOns as a separate user interface in the template editor
      doesn't exist yet.  So, for the purposes of this widget, we'll treat the navigation addOn
      as a native aspect of this widget, ie assert there will always be an addOn named 'navigateToSceneOnClick'
      in the addOns list of this widget, rather than trying to programmatically determine if it is there or not
      Perry Todo - Addons should pass entire Vue data obj: https://vuejs.org/v2/guide/render-function.html#The-Data-Object-In-Depth
      */
      attrs: {
        id: props.widgetId,
        //Todo - When AddOns are properly implemented the following line should be removed,
        //instead there should be code (per above comments) that hydrates this Vue data obj with
        //ones from each configured addon
        'data-adacadodotnavigationwidget': 'dot',
        'widget-id': `widget${props.widget.id}`,
        class: props.animationClass,
      },
    },
    [hoverStyles, ...sourceElement]
  )
}

function computeDotsContainer(widget, isResizing, buttonCount) {
  const widgetConfig = widget.value.config
  if (!isResizing) {
    // calculate width/height of dots container based on dot width/height/spacing
    if (widgetConfig.orientation === 'horizontal') {
      widget.layout.width = buttonCount * widgetConfig.dotWidth + (buttonCount - 1) * widgetConfig.dotSpacing
      widget.layout.height = widgetConfig.dotHeight
    } else {
      widget.layout.height = buttonCount * widgetConfig.dotHeight + (buttonCount - 1) * widgetConfig.dotSpacing
      widget.layout.width = widgetConfig.dotWidth
    }
  } else {
    // when resizing, calculate dot width/height based on width/height of container
    let dotWidthAndHeight = 0
    if (widgetConfig.orientation === 'horizontal') {
      // use container width to calculate dot size for horizontal navigation
      dotWidthAndHeight = Math.floor((widget.layout.width - widgetConfig.dotSpacing * (buttonCount - 1)) / buttonCount)
      widget.layout.height = dotWidthAndHeight
    } else {
      // use container height to calculate dot size for vertical navigation
      dotWidthAndHeight = Math.floor((widget.layout.height - widgetConfig.dotSpacing * (buttonCount - 1)) / buttonCount)
      widget.layout.width = dotWidthAndHeight
    }
    widgetConfig.dotHeight = dotWidthAndHeight
    widgetConfig.dotWidth = dotWidthAndHeight
  }
}

export default {
  functional: true,
  props: {
    widget: {
      type: Object,
      required: true,
    },
    animationClass: {
      type: String,
      default: '',
    },
    widgetId: {
      type: String,
      required: false,
    },
    zModifier: {
      type: Number,
      default: 0,
    },
    isWorkSpaceMounted: {
      type: Boolean,
      default: false,
    },
    isRenderingInsideAceEditor: {
      type: Boolean,
      default: false,
    },
    isRenderingInsideLayerTool: {
      type: Boolean,
      default: false,
    },
    productDataCount: {
      type: Number,
      default: 0,
    },
    isResizing: {
      type: Boolean,
      default: false,
    },
    quickStart: {
      type: Boolean,
      default: false,
    },
  },
  render($h, context) {
    const { widget, productDataCount, isWorkSpaceMounted, isRenderingInsideLayerTool, isResizing, quickStart} = context.props
    const widgetConfig = widget.value.config

    // fix me: add 'isAspectRatioLocked' to old widget
    if (!widget.layout.isAspectRatioLocked) widget.layout.isAspectRatioLocked = true

    // if productDataCount has changed update the new value to widget object
    // and announce template has changed to regenerate template html
    if (
      !isRenderingInsideLayerTool &&
      isWorkSpaceMounted &&
      productDataCount !== undefined &&
      widgetConfig.dotButtonCount !== quickStart ? quickStart.productCount : productDataCount
    ) {
      widgetConfig.dotButtonCount = quickStart ? quickStart.productCount : productDataCount
    }
    const buttonCount = quickStart ? quickStart.productCount : widget.value.config.dotButtonCount || widget.value.config.previewDots
    const isPreviewDot = !widget.value.config.dotButtonCount
    computeDotsContainer(widget, isResizing, buttonCount)
    let dotElements = []
    if (buttonCount) {
      for (let i = 0; i < buttonCount; i++) {
        const isLastDot = i === buttonCount - 1
        const isFirstDot = i === 0
        const options = {
          isFirstDot,
          isLastDot,
          isPreviewDot,
        }
        const navElement = $h('div', {
          style: dotElementStyle(context.props, options),
          attrs: {
            // assign template/product index of each button
            'data-adacadodotnavigationbutton': `${i}`,
          },
        })
        dotElements.push(navElement)
      }
    }

    // wrap with div
    return withDivContainer.call(context, dotElements, $h)
  },
}
